<template>
  <v-footer v-if="usuarioLogado" color="#59616b" width="auto" style="justify-content: center;">
    <p class="textofooter" style="margin: 0px">COPYRIGHT © {{ new Date().getFullYear() }} - AIFIT</p>
    <v-spacer></v-spacer>
    <v-btn icon dark href="https://www.instagram.com/intelite_tecnologia/" target="_blank">
      <img src="../assets/instagram.png">
    </v-btn>
  </v-footer>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    data () {
      return {
        //
      }
    },

    mounted: function () {
      if (sessionStorage.getItem('accToken') != null)
        this.$store.dispatch('Logar', this.token)
    },

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      username: state => state.UserName
    }),
  }
</script>

<style>
  .textofooter {
    font-size: 11px;
    position: absolute;
    color: white;
    /* right: 42%; */
    /* left:42%; */
    margin-right: -50px;
    margin-left: -50px;
  }

  .imagemLogoFooter {
    margin-left: 45px;
    left: 5%;
  }
</style>
